<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    Save Dispatch for ({{ data.workOrderNumber }})
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <form #dispatchForm="ngForm" id="loadDispatchForm">
    <div class="mat-elevation-z8 viewport">
      <table mat-table [dataSource]="dataSource"  
             class="mat-table" [trackBy]="trackByDispatchId">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div style="margin-top: -12px;text-align: left;">
              <mat-checkbox [(ngModel)]="row.bcheckbox" [name]="'selectedType_' + i"
                            style="margin-right: 8px; vertical-align: middle;"></mat-checkbox>
              {{ row.type }}
            </div>
            <input type="hidden" [(ngModel)]="row.fsLoadScheduleId" [name]="'fsLoadScheduleId_' + row.id + i">
            <input type="hidden" [(ngModel)]="row.id" [name]="'id_' + row.id + i">
            <input type="hidden" [(ngModel)]="row.type" [name]="'type_' + row.id + i">
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-form-field appearance="outline" class="dispatch-input-field">
              <input matInput type="email" [(ngModel)]="row.email" [name]="'email_' + i"
                     placeholder="Enter Email Address"
                     pattern="^[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$" #emailInput="ngModel">
              <mat-error *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
                Enter a valid email
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef> SMS (Mobile #) </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <mat-form-field appearance="outline" class="dispatch-input-field">
              <input matInput type="tel" [(ngModel)]="row.phoneNumber" [name]="'phoneNumber_' + i"
                     placeholder="(999) 000-0000" (input)="formatPhoneNumber($event, 'phoneNumber_' + i)"
                     pattern="^\(?([0-9]{3})\)?[\-\. ]?([0-9]{3})[\-\. ]?([0-9]{4})$" #phoneInput="ngModel">
              <mat-error *ngIf="phoneInput.invalid && (phoneInput.dirty || phoneInput.touched)">
                Phone number is incomplete
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">No dispatch information available.</td>
        </tr>
      </table>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" mat-primary (click)="onClose()" id="btnCancelModal" data-testid="btnCancelModal">
    Cancel
  </button>
  <button mat-raised-button color="primary" mat-primary (click)="onSave()" id="btnSaveDispatch" data-testid="btnSaveDispatch"
          [disabled]="dispatchForm.invalid">
    Save
  </button>
</mat-dialog-actions>
